module.exports = __webpack_public_path__ + "media/bom/stock-bab17ef0.png";